import PropTypes from 'prop-types';
import Image from 'next/dist/client/image';
import { Card } from 'react-bootstrap';
import { IC_ADD_FEMALE_MEMBER } from '../../../Assets/images';
import { ButtonBase } from '../../Forms';
import SectionBox from '../../SectionBox/SectionBox';
import { PersonalizationStyled } from './PersonalizationStyled';
import { useEffect } from 'react';
import { dataLayerSendEvent } from '../../../Utility/analytics-utils';
import { MY_ASTER_CATEGORY } from '../../../Constants/analytics';

const PersonalizationCard = ({ setShowExistingProfileView, referrerPage }) => {
  const hasLinkedProfile =
    localStorage.getItem('showLinkedProfiles') === 'true' || localStorage.getItem('showLinkedProfiles') === null;
  
  useEffect(() => {
    dataLayerSendEvent('linked_profiles_card_viewed', {
      screen_name: 'asco homepage',
      page_type: 'homepage',
      myaster_category: MY_ASTER_CATEGORY?.ASCO,
    });
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    setShowExistingProfileView(true);
    dataLayerSendEvent('check_profiles_click', {
      screen_name: 'asco homepage',
      page_type: 'homepage',
      myaster_category: MY_ASTER_CATEGORY?.ASCO,
    });
  };

  if (!hasLinkedProfile) {
    return null;
  }

  return (
    <PersonalizationStyled>
      <SectionBox customClass="section-title" customOuterClass="pb-4 whiteBg">
        <Card>
          <Card.Body>
            <div className="Personalization_card">
              <div>
                <Image className="personalization_image" src={IC_ADD_FEMALE_MEMBER} width={66} height={70} />
              </div>
              <div className="personalization_text">
                <div className="custom_block_title">Linked Profiles Detected</div>
                <div className="description">
                  {`We've found account(s) linked to your mobile number. Please verify and link if they belong to you.`}
                </div>
              </div>
              <div className="personalization_button">
                <ButtonBase
                  size="sm"
                  text="Check Profiles"
                  variant="primary"
                  onClick={(e) => {
                    handleSubmit(e);
                  }}
                />
              </div>
            </div>
          </Card.Body>
        </Card>
      </SectionBox>
    </PersonalizationStyled>
  );
};

PersonalizationCard.propTypes = {
  setShowExistingProfileView: PropTypes.func.isRequired,
};

export default PersonalizationCard;
